import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from '../../utils/StyledCol'
import Row from '../../utils/StyledRow'
import styled from 'styled-components'
import LinkHandler from '../../utils/LinkHandler'
import Link from '../../utils/Link'

const JobsColumn = styled.ul`
  margin: 10px 0;
  padding-left: 0;
  overflow: hidden;
  max-width: 100%;
  & li::before {
    background: #333;
    border-radius: 6px;
    content: " ";
    display: block;
    height: 4px;
    left: 0;
    position: absolute;
    top: 7px;
    width: 4px;
  }

  & li {
    line-height: 18px;
    list-style: none;
    margin-bottom: 7px;
    padding-left: 13px;
    position: relative;
  }

  & li a {
    color: #333;
    font-size: 13px;
  }
`

class JobsContainer extends Component {
  renderJobsColumn (boxes) {
    const {
      utmParams,
      admon
    } = this.props

    return (
      <Col xs={6}>
        <JobsColumn>
          {
            boxes.map(box => {
              const {
                guid,
                link,
                title
              } = box

              const location = new LinkHandler(link).mergeUTMParams(utmParams).applySASRedirect(admon).link
              return (
                <li key={guid}>
                  <Link href={location}>
                    {title}
                  </Link>
                </li>
              )
            })
          }
        </JobsColumn>
      </Col>
    )
  }

  render () {
    const {
      boxes
    } = this.props

    if (!boxes || !boxes.length) {
      return null
    }

    const halfIndex = Math.ceil(boxes.length / 2)

    return (
      <Row>
        { this.renderJobsColumn(boxes.slice(0, halfIndex)) }
        { this.renderJobsColumn(boxes.slice(halfIndex)) }
      </Row>
    )
  }
}

JobsContainer.propTypes = {
  boxes: PropTypes.array.isRequired,
  utmParams: PropTypes.object.isRequired
}

export default JobsContainer
